// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { VFileUpload } from "vuetify/labs/VFileUpload";
import { VDateInput } from "vuetify/labs/VDateInput";
import { VTimePicker } from "vuetify/lib/labs/VTimePicker";

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify({
  components: {
    VFileUpload,
    VDateInput,
    VTimePicker
  },

  theme: {
    // defaultTheme: "dark",
  },
});
